import AssetLoader from '@base/asset-loader/AssetLoader'
import {asyncFactory, getInstance} from '@base/di'

const BROWSER_LOCATOR_LOCATION_KEY = 'browserLocatorLocation'

export type BrowserLocation = {
  latitude: string
  longitude: string
  ip: string
  countryCode: string
  countryName: string
  subdivision?: string | null
  city: string
}

declare global {
  interface Window {
    geoip2: any
  }
}

async function fetchLocationFromMaxMind(): Promise<BrowserLocation> {
  const loader = new AssetLoader(false)
  await loader.loadScript(
    'https://js.maxmind.com/js/apis/geoip2/v2.0/geoip2.js'
  )

  return new Promise((resolve, reject) => {
    if (window.geoip2) {
      window.geoip2.city(
        (data) => {
          let subdivision = null

          if (data.most_specific_subdivision) {
            subdivision = data.most_specific_subdivision.iso_code
          }

          resolve({
            latitude: data.location?.latitude,
            longitude: data.location?.longitude,
            ip: data.traits?.ip_address,
            countryCode: data.country?.iso_code,
            countryName: data.country?.names?.en,
            subdivision,
            city: data.city?.names?.en,
          } as BrowserLocation)
        },
        (err) => {
          reject(err)
        }
      )
    } else {
      reject(new Error('Maxmind is not loaded properly'))
    }
  })
}

export const locationFactory = asyncFactory(
  async (): Promise<BrowserLocation> => {
    const storedLocation = window.sessionStorage.getItem(
      BROWSER_LOCATOR_LOCATION_KEY
    )

    if (storedLocation) {
      try {
        return JSON.parse(storedLocation)
      } catch (_) {
        /* fallthrough */
      }
    }

    const fetchedLocation = await fetchLocationFromMaxMind()

    window.sessionStorage.setItem(
      BROWSER_LOCATOR_LOCATION_KEY,
      JSON.stringify(fetchedLocation)
    )

    return fetchedLocation
  },
  {name: 'BrowserLocatorLocation'}
)

export default async function getLocation(): Promise<any> {
  return getInstance(locationFactory)
}
